/**
 * Created by jv on 08/02/2018.
 */
//js
const Shared = require("Sources/shared");
const LanguageManager = require("Sources/services/language-manager");
const utils = require("Sources/utils/utils");
const log = require("Sources/utils/logger")();

//Styles
require("Styles/pages/legal/privacy-policy.scss");

// Partial views
const htmlReq = require.context("Views/legal/partials", true, /privacy-policy\.html$/);

$(function () {
  Shared.shouldSetUpCreditsDialog = false;
  Shared.init();
  PrivacyPolicyPage.init();
});

let PrivacyPolicyPage = {};

((PrivacyPolicyPage) => {
  PrivacyPolicyPage.init = function () {
    setUpHtmlPartial();
  };

  function setUpHtmlPartial() {
    let htmlRequire = `./${LanguageManager.getCurrentLocale()}/privacy-policy.html`;
    let htmlPartial;

    let defaultRequire = "./default/privacy-policy.html";

    if (htmlReq.keys().includes(htmlRequire)) {
      htmlPartial = htmlReq(htmlRequire);
      $("#privacy-policy-content").html(htmlPartial);
    } else if (htmlReq.keys().includes(defaultRequire)) {
      htmlPartial = htmlReq(defaultRequire);
      $("#privacy-policy-content").html(htmlPartial);
    } else {
      log.error("Couldn't find html partial [%s] in known html partial list: %o", htmlRequire, htmlReq.keys());
      utils.redirect("/");
    }
  }
})(PrivacyPolicyPage);



// WEBPACK FOOTER //
// ./app/js/entries/legal/privacy-policy.js